import { render, staticRenderFns } from "./TheMobileNavigation.vue?vue&type=template&id=20dc4f4e&scoped=true"
import script from "./TheMobileNavigation.vue?vue&type=script&lang=js"
export * from "./TheMobileNavigation.vue?vue&type=script&lang=js"
import style0 from "./TheMobileNavigation.vue?vue&type=style&index=0&id=20dc4f4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc4f4e",
  null
  
)

export default component.exports